import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';

import { 
    NG_VALUE_ACCESSOR, 
    NG_VALIDATORS 
} from '@angular/forms';
import { PgSelectComponent, PgSelectOption } from '../pg-select/pg-select.component';

@Component({
    selector: 'app-pg-list-editor',
    templateUrl: './pg-list-editor.component.html',
    styleUrls: ['./pg-list-editor.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PgListEditorComponent),
            multi: true
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PgListEditorComponent),
            multi: true,
        }],
    standalone: false
})

export class PgListEditorComponent extends PgSelectComponent implements OnInit, OnDestroy {
    @Input() order:boolean;
    
    multi = true;

    private _onOutsideClick:() => void

    ngOnInit(): void {
        this._onOutsideClick = () => {
            this.onInputBlur()
        }

        window.addEventListener('click', this._onOutsideClick)
    }

    ngOnDestroy(): void {
        window.removeEventListener('click', this._onOutsideClick)
    }

    moveSelectedOption(index:number, offset:number) {
        let _swap = this.selectedOptions[index];
        this.selectedOptions[index] = this.selectedOptions[index + offset];
        this.selectedOptions[index + offset] = _swap;

        this.setValue();
        this.setText();
        if(this._onChange != null) this._onChange(this.value);
    }

    clickFocus(event:MouseEvent) {
        this.onInputFocus()
        event.stopPropagation()
    }
}

